/**
 * @fileoverview Zod schema for the Edit Client form (PATCH /sales/clients/{tenantId}).
 * @description The same sections and rules as the Edit Prospect form, except that the registration
 * number is optional (a client may never have had one on file; clearing one that exists is refused by
 * the backend). The bank type and the registration number are editable here, behind a confirmation.
 * Messages reuse the New Prospect form's translation keys, translated at the display call site.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { z } from 'zod'

import { editProspectDetailsFormSchema } from './edit-prospect-details-form.schema'

/** @description The Edit Client form's rules. */
export const editClientFormSchema = editProspectDetailsFormSchema.extend({
  regNumber: z.string().trim(),
})

/** @description The Edit Client form's values. */
export type EditClientFormValues = z.infer<typeof editClientFormSchema>
